import styled from "styled-components";
const ToolbarItem = styled("div")(
  {
    boxSizing: "content-box",
    // Firefox won't size properly otherwise
    margin: -4,
    minWidth: 0,
    overflow: "hidden",
    padding: "4px 8px",
    position: "relative",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  ({ expand }) => ({
    maxWidth: expand ? "none" : "max-content"
  }),
  ({ flex }) => flex === 0 ? {
    flex: "0 0 auto"
  } : {
    flex: `${flex} ${flex} 0`
  }
);
export {
  ToolbarItem
};
